<script setup lang="ts">
import { useRoute } from 'vue-router'
import { computed } from 'vue'
import TabBar from '@/components/TabBar.vue'

const route = useRoute()

// 底部导航栏显示的页面路径
const tabBarRoutes = ['/', '/campus', '/academic', '/profile']

const showTabBar = computed(() => tabBarRoutes.includes(route.path))
</script>

<template>
  <div class="app-container">
    <router-view />
    <van-overlay v-if="!showTabBar" :show="false" />
    <TabBar v-if="showTabBar" />
  </div>
</template>

<style lang="scss">
.app-container {
  min-height: 100vh;
  background-color: #f5f6fa;
  padding-bottom: calc(50px + env(safe-area-inset-bottom));
}
</style>
